<template>
  <div>
    <Note v-if="assertSetting('personLoad', 1)"/>
    <Edit/>
    <Vehicles/>
    <PasswordChange/>
    <ChangeGroup v-if="assertSetting('personEdit', 1)"/>
    <ModifyCredit v-if="assertSetting('editBaxterBucks', 1)"/>
    <Delete v-if="assertSetting('personEdit', 1)"/>
  </div>
</template>

<script>
// import components
import Note from '@/components/person/Note'
import Edit from '@/components/person/Edit'
import Vehicles from '@/components/person/Vehicles'
import PasswordChange from '@/components/person/PasswordChange'
import ChangeGroup from '@/components/person/ChangeGroup'
import ModifyCredit from '@/components/person/ModifyCredit'
import Delete from '@/components/person/Delete'

export default {
  components: {
    Note,
    Edit,
    Vehicles,
    PasswordChange,
    ChangeGroup,
    ModifyCredit,
    Delete
  }
}
</script>
